import { IconButton } from "@mui/material";
import * as React from "react";

import {
  GitHubIcon,
  LinkedInIcon,
  TwitterIcon,
} from "@/shared/foundation/icons/mui";

export const RobotoCommunity: React.FC = () => {
  return (
    <>
      <IconButton
        href="https://github.com/roboto-ai"
        target="_blank"
        sx={{
          ":hover": {
            color: "var(--icon-color-hover)",
          },
        }}
      >
        <GitHubIcon fontSize="small" />
      </IconButton>

      <IconButton
        href="https://www.linkedin.com/company/robotoai"
        target="_blank"
        sx={{
          ":hover": {
            color: "var(--icon-color-hover)",
          },
        }}
      >
        <LinkedInIcon fontSize="small" />
      </IconButton>

      <IconButton
        href="https://twitter.com/roboto_ai"
        target="_blank"
        sx={{
          ":hover": {
            color: "var(--icon-color-hover)",
          },
        }}
      >
        <TwitterIcon fontSize="small" />
      </IconButton>
    </>
  );
};
